<template>
  <div class="user-search-form">
    <b-card>
      <template #header>
        <h5 class="mb-0">
          <i class="fas fa-search mr-2"></i>
          Advanced User Search
        </h5>
      </template>

      <b-form @submit.prevent="onSubmit" @reset="onReset">
        <!-- Search Fields -->
        <b-row>
          <b-col md="2">
            <b-form-group label="First Name" label-for="firstName">
              <b-form-input
                id="firstName"
                v-model="form.firstName"
                placeholder="Enter first name"
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>
          
          <b-col md="2">
            <b-form-group label="Last Name" label-for="lastName">
              <b-form-input
                id="lastName"
                v-model="form.lastName"
                placeholder="Enter last name"
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>
          
          <b-col md="3">
            <b-form-group label="Email" label-for="email">
              <b-form-input
                id="email"
                v-model="form.email"
                type="email"
                placeholder="Enter email address"
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>
          
          <b-col md="2">
            <b-form-group label="Mobile" label-for="mobile">
              <b-form-input
                id="mobile"
                v-model="form.mobile"
                placeholder="Enter phone number"
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>
          
          <b-col md="3">
            <b-form-group label="License Number" label-for="licenseNumber">
              <b-form-input
                id="licenseNumber"
                v-model="form.licenseNumber"
                placeholder="Enter doctor license"
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Action Buttons -->
        <b-row class="mt-3">
          <b-col>
            <b-button-group>
              <b-button
                type="submit"
                variant="primary"
                :disabled="isLoading"
              >
                <i class="fas fa-search mr-1"></i>
                Search Users
              </b-button>
              
              <b-button
                type="reset"
                variant="outline-secondary"
                :disabled="isLoading"
              >
                <i class="fas fa-times mr-1"></i>
                Clear
              </b-button>
              
            </b-button-group>
          </b-col>
        </b-row>

        <!-- Search Results Summary -->
        <b-row v-if="lastSearchCriteria" class="mt-3">
          <b-col>
            <b-alert show variant="info" class="mb-0">
              <small>
                <strong>Last Search:</strong>
                <span v-for="(value, key) in lastSearchCriteria" :key="key" class="mr-2">
                  <strong>{{ formatSearchKey(key) }}:</strong> {{ value }}
                </span>
              </small>
            </b-alert>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "UserSearchForm",
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    lastSearchCriteria: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        licenseNumber: ''
      }
    };
  },
  methods: {
    onSubmit() {
      const searchParams = this.buildSearchParams();
      this.$emit('search', searchParams);
    },
    
    onReset() {
      this.form = {
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        licenseNumber: ''
      };
    },
    
    buildSearchParams() {
      const params = {};
      
      // Add non-empty string values
      Object.keys(this.form).forEach(key => {
        const value = this.form[key];
        if (value !== null && value !== undefined && value !== '') {
          params[key] = value;
        }
      });
      
      return params;
    },
    
    formatSearchKey(key) {
      const keyMap = {
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        mobile: 'Mobile',
        licenseNumber: 'License Number'
      };
      return keyMap[key] || key;
    }
  }
};
</script>

<style scoped>
.user-search-form .card {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
}

.user-search-form .card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.user-search-form .form-group label {
  font-weight: 500;
  color: #495057;
}

.user-search-form .btn-group .btn {
  border-radius: 0.375rem;
}

.user-search-form .btn-group .btn:not(:last-child) {
  margin-right: 0.5rem;
}
</style>